import { Bank } from '../types';

export const Banks: Bank[] = [
  {
    name: 'Banco BICE',
    sbifCode: 28,
    URL: 'https://www.bice.cl',
    hasPAC: true
  },
  {
    name: 'Banco Consorcio',
    sbifCode: 55,
    URL: 'https://www.bancoconsorcio.cl',
    hasPAC: true
  },
  {
    name: 'Banco Corpbanca',
    sbifCode: 39,
    URL: 'https://banco.itau.cl/wps/portal/BICPublico/home',
    hasPAC: true
  },
  {
    name: 'Banco Crédito e Inversiones (BCI)',
    sbifCode: 16,
    URL: 'https://www.bci.cl/personas',
    hasPAC: true,
    manualPAC:
      'https://res.cloudinary.com/compara/image/upload/v1603991786/emails/Documentos/Manual%20PAC/PAC_Banco_BCI.pdf'
  },
  {
    name: 'Banco Estado',
    sbifCode: 12,
    URL: 'https://www.bancoestado.cl',
    hasPAC: true,
    manualPAC:
      'https://res.cloudinary.com/compara/image/upload/v1603987228/emails/Documentos/Manual%20PAC/PAC_Banco_estado.pdf'
  },
  {
    name: 'Banco Falabella',
    sbifCode: 51,
    URL: 'https://www.bancofalabella.cl',
    hasPAC: true,
    manualPAC:
      'https://res.cloudinary.com/compara/image/upload/v1603987063/emails/Documentos/Manual%20PAC/PAC_Banco_falabella.pdf'
  },
  {
    name: 'Banco Internacional',
    sbifCode: 9,
    URL: 'https://www.bancointernacional.cl',
    hasPAC: true
  },
  {
    name: 'Banco Ripley',
    sbifCode: 53,
    URL: 'https://www.bancoripley.cl'
  },
  {
    name: 'Banco Santander',
    sbifCode: 37,
    URL: 'https://www.santander.cl',
    hasPAC: true,
    manualPAC:
      'https://res.cloudinary.com/compara/image/upload/v1603991848/emails/Documentos/Manual%20PAC/PAC_Banco_Santander.pdf'
  },
  {
    name: 'Banco Security',
    sbifCode: 49,
    URL: 'https://personas.bancosecurity.cl',
    hasPAC: true,
    manualPAC:
      'https://res.cloudinary.com/compara/image/upload/v1603991939/emails/Documentos/Manual%20PAC/PAC_Banco_security.pdf'
  },
  {
    name: 'Banco de Chile / Edwards-Citi',
    sbifCode: 1,
    URL: 'https://ww3.bancochile.cl',
    hasPAC: true,
    manualPAC:
      'https://res.cloudinary.com/compara/image/upload/v1603991986/emails/Documentos/Manual%20PAC/PAC_Banco_de_Chile.pdf'
  },
  {
    name: 'Banco del Desarrollo',
    sbifCode: 14,
    URL: 'https://www.scotiabankchile.cl',
    hasPAC: true,
    manualPAC:
      'https://res.cloudinary.com/compara/image/upload/v1605204417/emails/Documentos/Manual%20PAC/PAC_Banco__scotiabank.pdf'
  },
  {
    name: 'Coopeuch',
    sbifCode: 672,
    URL: 'https://www.coopeuch.cl/web/guest'
  },
  {
    name: 'Itaú',
    sbifCode: 39,
    URL: 'https://banco.itau.cl/wps/portal/BICPublico/home',
    hasPAC: true
  },
  {
    name: 'Scotiabank',
    sbifCode: 14,
    URL: 'https://www.scotiabankchile.cl',
    hasPAC: true,
    manualPAC:
      'https://res.cloudinary.com/compara/image/upload/v1605204417/emails/Documentos/Manual%20PAC/PAC_Banco__scotiabank.pdf'
  },
  {
    name: 'Scotiabank Azul',
    sbifCode: 14,
    URL: 'https://www.scotiabankchile.cl',
    hasPAC: true,
    manualPAC:
      'https://res.cloudinary.com/compara/image/upload/v1605204417/emails/Documentos/Manual%20PAC/PAC_Banco__scotiabank.pdf'
  },
  {
    name: 'Banco do Brasil',
    sbifCode: 17,
    URL: 'https://www.bb.com.br/pbb/pagina-inicial/atendimento/bb-no-mundo/banco-do-brasil-no-chile'
  },
  {
    name: 'JP Morgan Chase Bank',
    sbifCode: 41,
    URL: 'https://www.jpmorgan.com/CL/en/about-us'
  },
  {
    name: 'Banco de la Nación Argentina',
    sbifCode: 43,
    URL: 'https://www.bna.com.ar/Personas'
  },
  {
    name: 'MUFG Bank',
    sbifCode: 45,
    URL: 'https://www.bk.mufg.jp/global'
  },
  {
    name: 'China Construction Bank',
    sbifCode: 60,
    URL: 'http://www.ccb.com/chile/lng/indexv3.html'
  },
  {
    name: 'Bank of China',
    sbifCode: 61,
    URL: 'https://www.bankofchina.com/cl/es/aboutus/ab1/201803/t20180322_11786200.html'
  }
];
